import styled from "styled-components";
import { getTranslation } from "../../../../../../services/Utility";

const Wrapper = styled.div`
  max-width: 171px !important;
  background-color: ${(props) =>
    props.theme.colors.newColors.otherColors.bgContainer};
  border-radius: 5px;
  color: #dedee9;
  margin-top: 20px;
`;

const Option = styled.h2`
  font-weight: 500;
  font-size: 16px;
  @media (min-width: 998px) {
    font-size: 18px;
  }
  padding: 10px 20px;
  white-space: nowrap;
  cursor: pointer;
  color: ${(props) =>
    props.option
      ? props.theme.colors.primary
      : props.theme.colors.newColors.shades.title};
  border-right: ${(props) =>
    props.option
      ? `2px solid ${(props) =>
          props.theme.colors.newColors.otherColors.inputBorder}`
      : "2px solid transparent"};
`;

const SidebarOptions = ({ option, setOption }) => {
  return (
    <Wrapper>
      <Option option={option === true} onClick={() => setOption(true)}>
        {getTranslation("358")}
      </Option>
      <Option
        style={{ color: "gray", cursor: "default" }}
        option={option === false} /*onClick={() => setOption(false)}*/
      >
        {getTranslation("359")}
      </Option>
    </Wrapper>
  );
};

export default SidebarOptions;
